import FluxUltra from './FluxUltra'

export default FluxUltra
